<!DOCTYPE html>
<q-loader  *ngIf="spinnerFlag" styleClass="custom-spinner"></q-loader>
<ng-container *ngIf="!loading">
    <q-main-layout compact="true" showNotificationTray="true">
        <router-outlet> </router-outlet>
        <q-toaster [toasterData]="toasterData" position="top-center"></q-toaster>
        <q-confirm-dialog ></q-confirm-dialog>

    </q-main-layout>

    <app-user-menu></app-user-menu>

</ng-container>
